<template>
  <div id="app">
    <el-container>
      <el-header>
        <shop-header msg="有品招商"></shop-header>
      </el-header>
      <el-main id="main">
        <keep-alive exclude="Rule">
          <router-view></router-view>
        </keep-alive>
        <shop-footer></shop-footer>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ShopHeader from '@/components/YPShopHeader.vue'
import ShopFooter from '@/components/YPShopFooter.vue'

export default {
  name: 'App',
  components: {
    ShopHeader,
    ShopFooter
  },
  methods: {
    ...mapMutations({
      getMerchantInfo: 'GET_MERCHAT_INFO'
    })
  }
}
</script>

<style lang="less">
@import './assets/styles/base.less';

#app {
  & ::-webkit-scrollbar {
    width: 1px;
  }

  & ::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 2px;
  }

  font-family: '微软雅黑', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  .el-container {
    height: 100vh;
    overflow: hidden;
  }

  .el-header {
    width: 100%;
    padding: 0 !important;
    z-index: 10;
  }

  .el-main {
    margin-top: -60px;
    padding: 60px 0 0;
  }
}
</style>
